import { ATTENTIVE_ORIGIN, handleAttentiveFrameMessages } from './handlers/attantive'

const ORIGIN_BY_HANDLER: Record<string, (event: MessageEvent) => void> = {
  [ATTENTIVE_ORIGIN]: handleAttentiveFrameMessages,
}

let eventListenerAttached = false

const attachMessageListener = () => {
  if (eventListenerAttached) return
  eventListenerAttached = true

  window.addEventListener('message', event => {
    const allowedOrigins = Object.keys(ORIGIN_BY_HANDLER)
    if (!allowedOrigins.includes(event.origin)) {
      return
    }

    const handler = ORIGIN_BY_HANDLER[event.origin]
    if (handler) {
      handler(event)
      return
    }
  })
}

export default attachMessageListener
